'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  cursor: pointer;\n  background: ', ';\n  color: ', ' !important;\n  font-size: 14px;\n  margin-left: 2px;\n  text-align: center;\n\n  ', '\n'], ['\n  cursor: pointer;\n  background: ', ';\n  color: ', ' !important;\n  font-size: 14px;\n  margin-left: 2px;\n  text-align: center;\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n        width: 30px;\n        line-height: 30px;\n      '], ['\n        width: 30px;\n        line-height: 30px;\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n        width: 20px;\n        line-height: 20px;\n      '], ['\n        width: 20px;\n        line-height: 20px;\n      ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactDeviceDetect = require('react-device-detect');

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors


var Action = _styledComponents2.default.div(_templateObject, _colors.grey, _colors.darkGrey, _reactDeviceDetect.isMobile ? (0, _styledComponents.css)(_templateObject2) : (0, _styledComponents.css)(_templateObject3));

exports.default = Action;